import { FC, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

type Size = 'sm' | 'lg'

type Props = {
  size?: Size
  items?: number
}

export const EmptyItems: FC<Props> = ({ size = 'sm', items = 4 }) => (
  <StyledEmptyWrapper>
    {new Array(items).fill({ item: '' }).map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <StyledItemWrapper key={index}>
        <StyledEmptyDot size={size} data-testid="empty-dot" />
        <StyledEmptyLine data-testid="empty-line" />
      </StyledItemWrapper>
    ))}
  </StyledEmptyWrapper>
)

const StyledEmptyDot = styled.div<{ size?: Size }>`
  height: ${(props) => (props?.size === 'sm' ? '16px' : '40px')};
  width: ${(props) => (props?.size === 'sm' ? '16px' : '40px')};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.color.neutral.color8};
  margin-right: 15px;
`

const StyledEmptyWrapper = styled.div`
  display: flex;
  margin-top: 10px;
  flex-direction: column;
`

const StyledItemWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`

const StyledEmptyLine = styled.div`
  height: 6px;
  width: 82px;
  border-radius: 100px;
  background-color: ${({ theme }) => theme.color.neutral.color8};
  margin-right: 15px;
`
